
export const required = (value, name) => {
  if (!value) {
    throw new Error(`${name} is required`);
  }
};


export const requireFields = (fields) => {
  Object.entries(fields).forEach(([name, value]) => {
    required(value, name);
  });
};